import { createSlotRecipe } from './runtime';

const fieldsetConfig = {"name":"fieldset","slots":["root","errorText","helperText","legend","control"]}

export const fieldset = /* @__PURE__ */ createSlotRecipe(fieldsetConfig)